module.exports = __webpack_public_path__ + "img/pic11@2x.bd6bce70.png";